module.exports = __webpack_public_path__ + "static/media/pneumaticTrailer.54dcc79a.svg";